import PersonAddIcon from '@mui/icons-material/PersonAdd';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useContext, useState } from 'react';

import NotEnoughSlotsModal from '@features/applications/components/NotEnoughSlotsModal/NotEnoughSlotsModal';
import { useCheckAvailableCalendarSlots } from '@features/applications/hooks/useCheckAvailableCalendarSlots';
import { DateIcon } from '../../../../vectors/index';
import CloseIcon from '@mui/icons-material/Close';
import { useCheckEnterpriseAvailableCalendarSlots } from '@features/applications/hooks/useCheckEnterpriseAvailableCalendarSlots';
import { authContext } from '@staffedupusa/shared-components';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import { lightPurple, linkedInBlue, primaryGreen } from '@styles/colors';

type ChooseInterviewStyleModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  subtitle: string;
  companyId: number;
  jobId: string | number;
  inviteToInterview: (inviteType: number) => void;
  scheduleInterview: () => void;
};

const ChooseInterviewStyleModal: FC<ChooseInterviewStyleModalProps> = ({
  isOpen,
  handleClose,
  subtitle,
  inviteToInterview,
  scheduleInterview,
  jobId,
  companyId,
}) => {
  const { authData } = useContext(authContext);

  const [isNotEnoughSlotsModalOpen, setIsNotEnoughSlotsModalOpen] =
    useState(false);

  const { calendarSlotsData } = useCheckAvailableCalendarSlots({
    enabled: authData?.user?.company ? true : false,
    companyId,
    jobId,
  });
  const { enterpriseCalendarSlotsData } =
    useCheckEnterpriseAvailableCalendarSlots({
      enabled: authData?.user?.enterprise ? true : false,
      companyId,
      jobId,
    });

  const handleInviteToInterview = (inviteType: number) => {
    if (authData.user?.enterprise) {
      if (
        enterpriseCalendarSlotsData?.status === 200 &&
        inviteType === 0 &&
        enterpriseCalendarSlotsData?.has_slots_available
      ) {
        inviteToInterview(inviteType);
      } else if (
        enterpriseCalendarSlotsData?.status === 200 &&
        inviteType === 1 &&
        enterpriseCalendarSlotsData?.has_blocks
      ) {
        inviteToInterview(inviteType);
      } else {
        setIsNotEnoughSlotsModalOpen(true);
      }
    } else {
      if (
        calendarSlotsData?.status === 200 &&
        inviteType === 0 &&
        calendarSlotsData?.has_slots_available
      ) {
        inviteToInterview(inviteType);
      } else if (
        calendarSlotsData?.status === 200 &&
        inviteType === 1 &&
        calendarSlotsData?.has_blocks
      ) {
        inviteToInterview(inviteType);
      } else {
        setIsNotEnoughSlotsModalOpen(true);
      }
    }
  };

  return (
    <>
      <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>
          <IconButton
            sx={{ position: 'absolute', top: 5, right: 5 }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          <br />
          <DateIcon />
          <br />
          <Typography variant="h4" sx={{ p: 3 }}>
            Choose interview style
            <Typography>{subtitle}</Typography>
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Stack sx={{ marginBottom: 3 }} spacing={2}>
            <Button
              color="secondary"
              variant="contained"
              sx={{ backgroundColor: linkedInBlue }}
              startIcon={<CalendarMonthIcon />}
              onClick={scheduleInterview}
            >
              Schedule Interview
            </Button>
            <Button
              color="secondary"
              variant="contained"
              sx={{ backgroundColor: primaryGreen }}
              startIcon={<PersonAddIcon />}
              onClick={() => handleInviteToInterview(0)}
            >
              Invite to Interview Block
            </Button>
            <Button
              color="secondary"
              variant="contained"
              sx={{ backgroundColor: lightPurple }}
              startIcon={<QuestionAnswerIcon />}
              onClick={() => handleInviteToInterview(1)}
            >
              Invite to Open Interview
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
      <NotEnoughSlotsModal
        isOpen={isNotEnoughSlotsModalOpen}
        handleClose={() => setIsNotEnoughSlotsModalOpen(false)}
      />
    </>
  );
};

export default ChooseInterviewStyleModal;
